"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./AlbertaHero.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-392":{"id":"e-392","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-393"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa22f0","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa22f0","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319237731},"e-394":{"id":"e-394","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-395"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa22f2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa22f2","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1716319344101},"e-396":{"id":"e-396","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-397"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa22fa","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa22fa","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1716319375621},"e-462":{"id":"e-462","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-19","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-463"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1716331421840},"e-482":{"id":"e-482","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-23","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-483"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1716505315197}},"actionLists":{"a-19":{"id":"a-19","title":"map-alberta","actionItemGroups":[{"actionItems":[{"id":"a-19-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2310"},"value":0,"unit":""}},{"id":"a-19-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2312"},"value":0,"unit":""}},{"id":"a-19-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2312"},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-19-n-11","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2313"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-19-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2310"},"value":1,"unit":""}},{"id":"a-19-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2312"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-19-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeInOut","duration":200,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2312"},"yValue":-20,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-19-n-12","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2313"},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-19-n-8","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2312"},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]},{"actionItems":[{"id":"a-19-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2312"},"yValue":-20,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]},{"actionItems":[{"id":"a-19-n-10","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"id":"284a8eee-6a21-f2c8-8e53-e945dbaa2312"},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1716331444848},"a-23":{"id":"a-23","title":"skeleton-loader","actionItemGroups":[{"actionItems":[{"id":"a-23-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":-100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":1000,"easing":"","duration":800,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":250,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-23-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":-100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-23-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":800,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":250,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1716505320174},"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function AlbertaHero({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "alberta_section-hero")}
      grid={{
        type: "section",
      }}
      tag="section"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "alberta_hero-container")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "alberta_hero-column")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "alberta_hero-content-wrap")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "alberta_hero-copy-wrap")}
              tag="div"
            >
              <_Builtin.Heading
                className={_utils.cx(
                  _styles,
                  "alberta_hero-heading",
                  "heading-style-h3"
                )}
                data-w-id="284a8eee-6a21-f2c8-8e53-e945dbaa22f0"
                tag="h1"
              >
                {"Alberta Landlords: Post your listing for free"}
              </_Builtin.Heading>
              <_Builtin.Paragraph
                className={_utils.cx(_styles, "text-color-secondary")}
                data-w-id="284a8eee-6a21-f2c8-8e53-e945dbaa22f2"
              >
                {"As an added bonus: use the code "}
                <_Builtin.Strong>{"ALBERTA"}</_Builtin.Strong>
                {" for a "}
                <_Builtin.Strong>{"FREE"}</_Builtin.Strong>
                {
                  " one-month trial of liv.rent's Growth plan*. Enjoy Multi-Platform Advertising and "
                }
                <_Builtin.Link
                  button={false}
                  block=""
                  options={{
                    href: "/screening",
                    target: "_blank",
                  }}
                >
                  {"Tenant Screening"}
                </_Builtin.Link>
                {" features at no cost."}
              </_Builtin.Paragraph>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "alberta_cta-form-card")}
              data-w-id="284a8eee-6a21-f2c8-8e53-e945dbaa22fa"
              tag="div"
              id="alberta_hero-cta-form"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "skeleton-loader")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "skeleton-loader-animation")}
                  tag="div"
                />
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "alberta_hero-logos-container")}
            tag="div"
          >
            <_Builtin.Paragraph
              className={_utils.cx(
                _styles,
                "subheading-style",
                "text-weight-bold"
              )}
            >
              {
                "Trusted by OVER 10,000 Landlords and Property Managers Across canada"
              }
            </_Builtin.Paragraph>
            <_Builtin.Block
              className={_utils.cx(_styles, "alberta_hero-logos-grid")}
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "alberta_logo-image")}
                id={_utils.cx(
                  _styles,
                  "w-node-_284a8eee-6a21-f2c8-8e53-e945dbaa2309-dbaa22ea"
                )}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/66478d827f6653f710126bde_logo-belmont-properties.webp"
              />
              <_Builtin.Image
                className={_utils.cx(_styles, "alberta_logo-image")}
                id={_utils.cx(
                  _styles,
                  "w-node-_284a8eee-6a21-f2c8-8e53-e945dbaa230a-dbaa22ea"
                )}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/66478d82f7e4a42a50338fca_logo-century21.webp"
              />
              <_Builtin.Image
                className={_utils.cx(_styles, "alberta_logo-image")}
                id={_utils.cx(
                  _styles,
                  "w-node-_284a8eee-6a21-f2c8-8e53-e945dbaa230b-dbaa22ea"
                )}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/66478d824ccf8f942eac802d_logo-cogir-real-estate.webp"
              />
              <_Builtin.Image
                className={_utils.cx(_styles, "alberta_logo-image")}
                id={_utils.cx(
                  _styles,
                  "w-node-_284a8eee-6a21-f2c8-8e53-e945dbaa230c-dbaa22ea"
                )}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/66478d82fa1df4d5c39278ee_logo-concert-properties.webp"
              />
              <_Builtin.Image
                className={_utils.cx(_styles, "alberta_logo-image")}
                id={_utils.cx(
                  _styles,
                  "w-node-_284a8eee-6a21-f2c8-8e53-e945dbaa230d-dbaa22ea"
                )}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/66478d82275a23372f1f0cc1_logo-macdonald-realty.webp"
              />
              <_Builtin.Image
                className={_utils.cx(_styles, "alberta_logo-image")}
                id={_utils.cx(
                  _styles,
                  "w-node-_284a8eee-6a21-f2c8-8e53-e945dbaa230e-dbaa22ea"
                )}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/66478d828d6ea481bd9b36e5_logo-pacific-cove-properties.webp"
              />
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "alberta_hero-image", "hide")}
          tag="div"
        >
          <_Builtin.Image
            className={_utils.cx(_styles, "alberta_hero-image-map")}
            data-w-id="284a8eee-6a21-f2c8-8e53-e945dbaa2310"
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/664d1cdffdaf7c5d59c6b503_image.svg"
          />
          <_Builtin.Block
            className={_utils.cx(_styles, "alberta_hero-map-overlay")}
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "alberta_hero-map-pin")}
              data-w-id="284a8eee-6a21-f2c8-8e53-e945dbaa2312"
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/664d1f0cb2b25ba5446a10ea_map-pin.svg"
            />
            <_Builtin.Block
              className={_utils.cx(_styles, "alberta_hero-popup-wrap")}
              data-w-id="284a8eee-6a21-f2c8-8e53-e945dbaa2313"
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "alberta_hero-popup-container")}
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "alberta_hero-popup-logo")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/664d28c7af3b9aeac419377a_logo-white.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "alberta_hero-popup-text")}
                  tag="div"
                >
                  {"is expanding to Alberta!"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "alberta_hero-popup-diamond")}
                tag="div"
              />
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
